import { render, staticRenderFns } from "./snailBookList.vue?vue&type=template&id=a11af630&scoped=true&"
import script from "./snailBookList.vue?vue&type=script&lang=js&"
export * from "./snailBookList.vue?vue&type=script&lang=js&"
import style0 from "./snailBookList.vue?vue&type=style&index=0&id=a11af630&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11af630",
  null
  
)

export default component.exports